import React from 'react';
import { Link } from 'react-router-dom';
import ConnectWallet from '../wallet/ConnectWallet';

const Header = () => (
  <header className="header">
    <div className="header-inner">
      <Link to="/" className="brand">
        <div className="brand-logo">
          <img src="/logo.png" alt="GalaxyXon" onError={(e) => { e.target.style.display = 'none'; }} />
        </div>
        <span className="brand-text">Galaxy<span className="x">X</span>on</span>
      </Link>
      <ConnectWallet />
    </div>
  </header>
);

export default Header;
